import { Component } from 'preact'

export default class NewPaybarButtonPublish extends Component {
  get text() {
    return I18n.t('newPaybar.submitButtonText.vacancy.publish')
  }

  get isEnabled() {
    return window.application.newPaybar.externalForm.isValid &&
      this.props.subscription.remainingPublications > 0
  }

  render() {
    return (
      <span className="newPaybarButtonSave has__statusCaption">
        <button
          className="newPaybarButtonSave-button button"
          onClick={ this.props.onPublish }
          dangerouslySetInnerHTML={{ __html: this.text }}
          disabled={ !this.isEnabled } />
      </span>
    )
  }
}
